require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-steven-stevenson.json") })
        }
      }, "path---blog-author-steven-stevenson");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-steven-stevenson!./.cache/json/blog-author-steven-stevenson.json
// module id = 711
// module chunks = 231608221292675